<template>
    <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
            <span>各年龄段性别比例</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="getData" icon="el-icon-refresh"></el-button>
        </div>
        <v-chart ref="chart" class="chart" :option="option" v-loading="loading" />
    </el-card>
</template>

<script>
export default {
    name: "lianhuaNianlingxingbie",
    data() {
        return {
            loading: false,
            option: {
                grid: {
                    top: 20,
                    bottom: 20
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        const ageRange = params[0].name;
                        const maleCount = params[0].data;
                        const femaleCount = params[1].data;
                        return `${ageRange}男${maleCount}人，女${femaleCount}人，合计${maleCount+femaleCount}人`;
                    }
                },
                xAxis: {
                    type: 'category',
                    data: ['34岁及以下', '35-44岁', '45岁及以上', '处级干部']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: [Math.floor(Math.random() * 1000), Math.floor(Math.random() * 1000), Math.floor(Math.random() * 1000), Math.floor(Math.random() * 1000)],
                        type: 'bar',
                        itemStyle: {
                            color: '#1890ff' // 指定第一组柱状图的颜色为绿色
                        }
                    },
                    {
                        data: [Math.floor(Math.random() * 1000), Math.floor(Math.random() * 1000), Math.floor(Math.random() * 1000), Math.floor(Math.random() * 1000)],
                        type: 'bar',
                        itemStyle: {
                            color: '#de6e6a' // 指定第一组柱状图的颜色为绿色
                        }
                    }
                ]
            }
        };
    },
    methods: {
        async getData() {
            this.loading = true
            const resp = await this.$http.get('/enterprise/lianhua/charts/nianlingxingbie')
            console.log(resp.data)
            this.option.xAxis.data = resp.data.name
            this.option.series[0].data = resp.data.nan
            this.option.series[1].data = resp.data.nv
            this.$refs['chart'].setOption(this.option)
            this.loading = false
        }
    },
    mounted() {
        this.getData().then(() => {
            this.$nextTick(() => {
                this.$refs.chart.resize()
            })
            window.addEventListener('resize', () => {
                if (this.$refs && this.$refs.chart) {
                    this.$refs.chart.resize()
                }
            })
        })
    }
};
</script>

<style scoped>
.chart {
    width: 100%;
    height: 300px;
}
</style>
